export interface Deferred<TValue> {
  readonly promise: Promise<TValue>;
  resolve(value: TValue): void;
  reject(reason: unknown): void;
}

/**
 * A promise settled from outside, e.g. a readiness others wait for. Not
 * `Promise.withResolvers`: the browsers the app supports lack it.
 */
export function createDeferred<TValue = void>(): Deferred<TValue> {
  let resolve: (value: TValue) => void = () => undefined;
  let reject: (reason: unknown) => void = () => undefined;
  const promise = new Promise<TValue>((resolvePromise, rejectPromise) => {
    resolve = resolvePromise;
    reject = rejectPromise;
  });
  return { promise, resolve, reject };
}
